import styled from 'styled-components';

import { getThemeFont } from 'lib/styles/getThemeFont';

export const Span = styled.span`
  ${getThemeFont}
`;
